import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import PagedEntitiesGrid from '../../common/components/PagedEntitiesGrid';
import Card from '../../common/components/Card';
import { withNamespaces } from 'react-i18next';
import moment from 'moment';
import FontAwesome from 'react-fontawesome';
import utils from '../../common/services/utils';

const Grid = ({ t, enableUserTimeZone, ...rest }) => {
    const renderItem = item => {
        const center = item.center;

        return <Card key={item.id} color='green' style={{ marginBottom: 15 }}>
            <div>
                <span className='circle-icon bg-light' style={{ float: 'left', marginRight: 8, marginTop: -5, width: 55, height: 55, lineHeight: '55px', fontSize: 24 }}>
                    <FontAwesome name='user' className='text-green' />
                </span>
                <div>
                    <span className='pull-right'>
                        {item.requiresQuestionnaire && <FontAwesome name='exclamation-triangle' />}
                        {item.documents.filter(d => d.fromParent).length > 0 && <FontAwesome name='paperclip' />}
                    </span>
                    <h4 style={{ marginBottom: 5 }}>{center && center.name}</h4>
                    <h4 style={{ marginBottom: 5 }} className='text-muted'>{`#${item.id}`} {t(`IndividualConsultationType_${item.consultationType}`)}</h4>
                    <h4 style={{ marginBottom: 5 }} className='text-muted'><FontAwesome name='calendar' /> {(enableUserTimeZone ? utils.convertToUserTime(item.consultationDate, center) : moment(item.consultationDate)).format('lll')}</h4>
                </div>
            </div>
            <div style={{ fontSize: 20, marginTop: 10, marginBottom: 10 }} className='grade-link'>{item.child && item.child.shortName}</div>
            <div style={{ position: 'relative' }}>
                <div className='text-muted'>
                    <div>{t('FO_Payment_Created')}</div>
                    <div>{moment(item.created).format('lll')}</div>
                </div>
                <div style={{ position: 'absolute', bottom: 0, right: 0 }}><Link to={`/individual-consultation/${item.id}`}>{t('FO_IndividualConsultation_Details')}</Link></div>
            </div>
        </Card>;
    }

    return <PagedEntitiesGrid itemsPerRow={1} itemComponent={renderItem} {...rest} />;
};

Grid.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        child: PropTypes.shape({
            shortName: PropTypes.string
        }),
        center: PropTypes.shape({
            name: PropTypes.string
        }),
        created: PropTypes.string
    }))
};

export default withNamespaces()(Grid);